import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=d1fe36c0&scoped=true&"
import script from "./Message.vue?vue&type=script&lang=js&"
export * from "./Message.vue?vue&type=script&lang=js&"
import style0 from "../../style/message-box.scss?vue&type=style&index=0&id=d1fe36c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fe36c0",
  null
  
)

export default component.exports